import styled from 'styled-components'
import playImg from '../../assets/play.png'
import { useNavigate } from 'react-router-dom'

function Page3Pc(prop) {
  const goods = prop.goods
  const gsId = prop.gsId
  const itemList = prop.goods?.itemDtoList
  const navigate = useNavigate()

  return (
    <MainContainer    
      style={{
        background:goods.gsBgColor
      }}
    >
      <Video>
        {(() => {
          if (goods.gsFileDto) {
            if (goods.gsFileDto.fileType == 'IMAGE') {
              return (
                <IMAGE
                  src={
                    process.env.REACT_APP_BASE_RESOURCES_API +
                    goods.gsFileDto.filePath
                  }
                ></IMAGE>
              )
            } else {
              return (
                <VIDEO
                  controls
                  playsInline
                  autoPlay
                  muted
                  src={
                    process.env.REACT_APP_BASE_RESOURCES_API +
                    goods.gsFileDto.filePath
                  }
                ></VIDEO>
              )
            }
          }
        })()}
      </Video>
      <Bottom>
        <TitleContainer>
          <Text1
            style={{
              color:goods.gsFontColor
            }}
          >{goods.gsName}</Text1>
          <Title1
            style={{
              color:goods.gsFontColor
            }}
          >{goods.gsEngName}</Title1>
          <Title2
            style={{
              color:goods.gsFontColor
            }}
          >{goods.gsKorName}</Title2>
        </TitleContainer>
        <BoxContainer>
          {itemList &&
            itemList.map((item) => {
              return (
                <Box
                  key={item.itemSeq}
                  onClick={() => {
                    navigate(`/item/${gsId}/${item.itemSeq}`)
                  }}
                >
                  <BoxTitle
                  
                    style={{
                      color:goods.gsFontColor
                    }}
                  >{item.itemName}</BoxTitle>
                  <View
                    style={{
                      color:goods.gsFontColor
                    }}
                  >VIEW</View>
                </Box>
              )
            })}
        </BoxContainer>
      </Bottom>
    </MainContainer>
  )
}

export default Page3Pc
const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 82px;
  margin-bottom: 102px;
  width: 100vw;
`
const Video = styled.div`
  width: 80vw;
  height: 45vw;
  max-width: 1126px;
  max-height: 633px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #000;
  margin-top: 20px;
`

const IMAGE = styled.img`
  width: 80vw;
  height: 45vw;
  max-width: 1126px;
  max-height: 633px;
`
const VIDEO = styled.video`
  width: 80vw;
  height: 45vw;
  max-width: 1126px;
  max-height: 633px;
`

const Play = styled.img`
  width: 108px;
  height: 108px;
`
const Bottom = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  padding: 0px 19.8px;
`
const Text1 = styled.p`
  font-family: Noto Sans KR;
  font-weight: 300;
  color: #b19c70;
  font-size: 18px;
  margin-right: 18px;
`
const TitleContainer = styled.p`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin-top: 20px;
  margin-left: -50px;
`
const Title1 = styled.p`
  font-family: GMarketSans;
  font-weight: 500;
  color: #b19c70;
  font-size: 36px;
`
const Title2 = styled.p`
  font-family: Noto Sans KR;
  font-weight: 300;
  color: #b19c70;
  font-size: 18px;
  margin-left: 10px;
`
const BoxContainer = styled.div`
  display: flex;
  width: 80vw;
  max-width: 1126px;
  flex-direction: row;
  gap: 17.5px;
  margin-top: 20.7px;
  margin-bottom: 100px;
`
const Box = styled.div`
  width: 100%;
  height: 46.2px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  border: 0.3px solid #70695b;
  cursor: pointer;
`
const BoxTitle = styled.p`
  font-family: Noto Sans KR;
  font-weight: 400;
  color: #b19c70;
  font-size: 15px;
  margin-left: 11.2px;
`
const View = styled.p`
  font-family: GMarketSans;
  font-weight: light;
  color: #b19c70;
  font-size: 8px;
  margin-right: 11.2px;
  margin-top: 2px;
`
